import { useCallback } from 'react';
import { toast } from 'sonner';
import { NotificationContent } from './NotificationContent';
import { NotificationItem } from './types';

const defaultNotificationValues: Pick<NotificationItem, 'level' | 'autoDismiss' | 'dismissible'> = {
  level: 'info',
  autoDismiss: 5,
  dismissible: 'both',
};

function getDuration(autoDismiss?: number | false) {
  if (autoDismiss === false || autoDismiss === 0) return Infinity;
  if (typeof autoDismiss === 'number') return autoDismiss * 1000;
  return (defaultNotificationValues.autoDismiss as number) * 1000;
}

export const useNotificationSystem = () => {
  const addNotification = useCallback((notification: NotificationItem) => {
    const finalNotification = { ...defaultNotificationValues, ...notification };

    toast.custom(
      (toastRef) => {
        return <NotificationContent dismiss={() => toast.dismiss(toastRef)} notification={finalNotification} />;
      },
      {
        duration: getDuration(finalNotification.autoDismiss),
        position: 'top-right',
      },
    );
  }, []);

  return { addNotification, clearNotifications: () => toast.dismiss() };
};
